import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarChart, MediumBarChart } from '../../components/bar-chart/';
import styles from './chart-area.module.scss';
import * as selectors from '../../reducers';
import { humanizeNumber } from '../../helpers/formatters';
import { entityLabelMatcher } from '../../helpers/label-mapper';

class ChartArea extends Component {
  constructor() {
    super();
    this.chartMapper = this.chartMapper.bind(this);
  }

  getLegendPhrase(chartData) {
    const { activeEntity, activeCouncil } = this.props;
    const area = activeCouncil
      ? 'regions of Queensland'
      : activeEntity[chartData.area];
    return area;
  }

  renderTrend(trend) {
    if (!trend) {
      return null;
    }

    const color = '#9a8273';
    return (
      <span
        style={{
          color,
          marginRight: 10,
        }}
      >
        {trend === '−' ? 'No Trend' : `Trend ${trend}`}
      </span>
    );
  }
  isTextBarChart(data) {
    return data.max === 'High';
  }

  chartMapper(chartData, index) {
    const {
      color,
      unit,
      activeEntity,
      activeCouncil,
      comparedEntity,
      comparedCouncil,
      title,
      entities,
      councils,
      visible,
      trend,
    } = this.props;

    switch (chartData.type) {
      case 'main':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
            // isStatic={
            //   activeCouncil
            //     ? false
            //     : activeEntity.entityCategory.includes('Other Institutions')
            // }
          >
            {this.renderTrend(trend)}
            {!activeCouncil &&
            activeEntity.entityCategory.includes('Other Institutions')
              ? ''
              : (activeEntity || activeCouncil).name}
          </BarChart>
        );
      case 'compared':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
          >
            {this.renderTrend(trend)}

            {(comparedEntity || comparedCouncil).name}
          </BarChart>
        );
      case 'median':
        const medianCount = activeEntity
          ? entities.filter(
              (entity) =>
                entity[chartData.area] === activeEntity[chartData.area] &&
                !entity.isBlank
            )
          : activeCouncil
          ? councils
          : undefined;
        if (
          chartData.max === 'High' ||
          (activeEntity &&
            activeEntity.entityCategory.includes('Other Institutions'))
        ) {
          // No median for text bar chart or institutions
          return <div></div>;
        }
        return (
          <MediumBarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
          >
            <div className={styles.chartLegend}>
              Median of {medianCount ? medianCount.length : 0}{' '}
              <span className={styles.chartLegendBold}>
                {this.getLegendPhrase(chartData)}
              </span>
            </div>
          </MediumBarChart>
        );
      case 'text':
        return activeEntity &&
          activeEntity.entityCategory.includes('Other Institutions') ? (
          <div></div>
        ) : (
          <div key={index} className={styles.chartBottomText}>
            <span>{title}</span> reported for Queensland{' '}
            {activeEntity &&
              entityLabelMatcher(
                activeEntity.entityCategory,
                'plural'
              ).toLocaleLowerCase()}{' '}
            ranged from {humanizeNumber(chartData.trueMin, unit)} to{' '}
            {humanizeNumber(chartData.trueMax, unit)}.{' '}
            {comparedEntity || this.isTextBarChart(chartData)
              ? null
              : 'Median is the middle value in the selected data range.'}
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { data } = this.props;
    return data.map(this.chartMapper);
  }
}

const mapStateToProps = (state) => ({
  activeEntity: selectors.getActiveEntity(state),
  activeCouncil: selectors.getActiveCouncil(state),
  entities: selectors.getEntities(state),
  comparedEntity: selectors.getComparedEntity(state),
  comparedCouncil: selectors.getComparedCouncil(state),
  councils: selectors.getRegions(state),
});

ChartArea.propTypes = {
  activeEntity: PropTypes.object,
  activeCouncil: PropTypes.object,
  comparedEntity: PropTypes.object,
  comparedCouncil: PropTypes.object,
  entities: PropTypes.array.isRequired,
  councils: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js